import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-07f550ee"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wrapper ml20 p20"
};
const _hoisted_2 = {
  class: "contract_container"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  key: 2,
  class: "coop"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_image = _resolveComponent("el-image");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_button, {
    style: {
      "display": "block"
    },
    type: "primary",
    icon: "ArrowLeft",
    circle: "",
    class: "mb20",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.back(-1))
  }), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_image, {
    src: 'data:image/png;base64,' + $setup.data.contractInfo?.contract,
    lazy: ""
  }, {
    error: _withCtx(() => [_createTextVNode(" 合同生成中，请稍等... ")]),
    _: 1
  }, 8, ["src"]), $setup.data.contractInfo?.signInfoList ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    class: "img secondPartySign",
    style: {
      bottom: 75 + 'vw',
      left: 40 + 'vw'
    },
    src: $setup.data.contractInfo.signInfoList[0].secondPartySign
  }, null, 8, _hoisted_3)) : _createCommentVNode("", true), $setup.data.contractInfo?.signInfoList ? (_openBlock(), _createElementBlock("img", {
    key: 1,
    class: "img secondPartySign",
    style: {
      bottom: 55 + 'vw',
      left: 40 + 'vw'
    },
    src: $setup.data.contractInfo.signInfoList[1].secondPartySign
  }, null, 8, _hoisted_4)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("img", {
    ref: "customerSign",
    class: "img customerSign",
    style: _normalizeStyle({
      bottom: $setup.data.contractInfo.yaxis * 0.14 + 'vw',
      left: $setup.data.contractInfo.xaxis * 0.15 + 'vw'
    }),
    src: $setup.data.contractInfo.customerSign
  }, null, 12, _hoisted_5), [[_vShow, $setup.data.isSeal]]), !$setup.mainStore.globalLoading ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_el_button, {
    type: "primary",
    class: "mr20",
    size: "large",
    onClick: $setup.sign
  }, {
    default: _withCtx(() => [_createTextVNode("已阅读合同，并同意盖章")]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    disabled: !$setup.data.isSeal,
    type: "success",
    size: "large",
    onClick: $setup.forwarderAgreementContractSign
  }, {
    default: _withCtx(() => [_createTextVNode("提交运输合同")]),
    _: 1
  }, 8, ["disabled", "onClick"])])) : _createCommentVNode("", true)])]);
}